import React, { memo, useState , useEffect} from "react";

import {
	Row, Col,
	Card, Button,
	Modal
} from "react-bootstrap";

import Details from "components/FullTest/MockOperations/ListeningDirectory/Details";
import Questions from "components/FullTest/MockOperations/Questions";
import { useSelector } from 'react-redux';
import NetworkManager from './NetworkManager';
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const Listening = memo( function Listening({
	mockData, questions, setSection, pending,localPending
}) {

	// Flag: 1 => Section Deatils.
	// Flag: 2 => Questions.
	const [flag, setFlag] = useState(mockData.skip < 2 ? 1 : 2);
	const [currQ, setCurrQ] = useState(-1);
    const intStatus = useSelector((state) => state.intStatus);
  const [isOnline, setIsOnline] = useState(true);
  const [, forceUpdate] = useState();
  
	const sectionTime = () => {
		return pending ? mockData.time : parseInt(mockData.mock.listening_time);
	};
    useEffect(() => {
    const connection = typeof intStatus === "undefined" ? true : intStatus;
    setIsOnline(connection);
    
    if (connection) {
      NetworkManager.retryFailedRequests();
    }
  }, [intStatus]);

	const nextButton = (e) => {
		// I have removed the pending condition to reload the page
		setFlag(prev => (prev + 1));
		setCurrQ(0);
	};
  
	return (
		<>
		 {/* {!isOnline && (
        <div className="network-warning">
          <i className="fa fa-wifi"></i>
          Connection lost. Your progress is saved and will sync when reconnected.
        </div>
      )} */}
			{flag === 1 &&
  <div className="content questionsArea deviceTestPage old-design p-0 test_width mock-container" id="test-card">
    <Row>
      <Col xs={12}>
        {/* TestHeader */}
        <Row className="m-0 test_width">
          <Row
            className="d-flex justify-content-between align-items-center w-100 h-50 mock-header-bg"
            style={{
              // backgroundColor: "#BFBABB",
              height: "40px !important",
            }}
          >
            <Col style={{ width: "fit-content", padding: "0" }}>
              <Card.Title tag="h4" className="m-0 mx-2">
                Language Academy - {mockData.mock.title}
              </Card.Title>
            </Col>
          </Row>
          <Row
            style={{
              backgroundColor: "#0081A4",
              minHeight: "40px",
            }}
            className="d-flex justify-content-end align-items-center px-4"
          >
            <div className="d-flex justify-content-end gap-3">
              {/* <i className="fa fa-expand text-white" style={{ cursor: "pointer" }}></i>
              <i className="fa fa-moon-o text-white" style={{ cursor: "pointer" }}></i> */}
              <img
                src={isFullScreen() ? ExitFullScreen : FullScreen}
                onClick={() => {
                toggleFullScreen();
                setTimeout(() => {
									forceUpdate({});
								}, 100);
                }}
                alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                className="toggle-icons"
              />
              <img
                src={isDarkMode() ? LightMode : DarkMode}
                onClick={() => {
                toggleTheme();
                forceUpdate({});
                }}
                alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                className="toggle-icons"
              />		
            </div>
          </Row>
        </Row>

        {/* Content with proper padding */}
        <div style={{ padding: "20px 40px 40px", paddingBottom: "80px" }}>
          <Details
            user={mockData.user_data}
            totalQuestions={questions.length}
            time={parseInt(mockData.mock.listening_time)}
          />
        </div>
      </Col>

      {/* BottomBtns */}
      <Col xs={12}>
        <div className="bottomBtns fixed-bottom-row mock-header-gap">
          <Row className="align-items-center mx-0 gap-1 fixed-bottom-row w-100 mock-header-gap">
            {/* <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}></Col> */}
            <Col className="text-center py-2 z-3 mock-bottom-btn-toggle flex-grow-1" style={{ minHeight: "50px" }}></Col>
            <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "20%",minHeight: "50px" }}>
              <Button
                variant="primary"
                onClick={nextButton}
                size="xs"
                className="mock-btn bottomBtnFont d-flex align-items-center"
              >
                NEXT
              </Button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  </div>
}

			{flag === 2 &&
				<Questions
					mockData={mockData}
					mock={mockData.mock}
					time={currQ === -1 ? sectionTime() : parseInt(mockData.mock.listening_time)}
					questions={questions}
					setSection={setSection}
					pending={pending}
					localPending={localPending}
					skip={3}
					currQ={currQ}
					isOnline={isOnline}
				/>
			}
		</>
	);
});

export default Listening;